<template>
    <div class="form-main">
		<el-form ref="ruleFormRef" inline-message :label-width="formLabelWidth" v-if="userInfo.checkMobile == 1 || userInfo.checkEmail == 1 || questionCheckOk">
			<el-form-item label="验证方式">
			  <el-radio-group v-model="verType" @change="wayChange">
			    <el-radio label="mobile" border v-if="userInfo.checkMobile == 1">手机验证</el-radio>
			    <el-radio label="email" border v-if="userInfo.checkEmail == 1">邮箱验证</el-radio>
			    <el-radio label="question" border v-if="questionCheckOk">密保验证</el-radio>
			  </el-radio-group>
			</el-form-item>
			<div v-if="verType === 'mobile'">
				<el-form-item label="手机号码">
				  <el-input v-model="mobile" disabled autocomplete="off" />
				</el-form-item>
				<div class="code">
				  <el-form-item label="验证码" :rules="[{ required: true }]">
				    <el-input v-model="code" autocomplete="off" />
				  </el-form-item>
				  <el-button type="primary" :disabled="mobileSend" @click="codeChange">{{mobileSendText}}</el-button>
				</div>
			</div>
			<div v-if="verType === 'email'">
				<el-form-item label="邮箱地址">
				  <el-input v-model="email" disabled autocomplete="off" />
				</el-form-item>
				<div class="code">
				  <el-form-item label="验证码" :rules="[{ required: true }]">
				    <el-input v-model="code" autocomplete="off" />
				  </el-form-item>
				  <el-button type="primary" :disabled="emailSend" @click="codeChange">{{emailSendText}}</el-button>
				</div>
			</div>
			<div v-if="verType === 'question'">
				<el-form-item label="密保问题">
				  <el-input v-model="question" disabled autocomplete="off" />
				</el-form-item>
				<el-form-item label="密保答案" :rules="[{ required: true }]">
				  <el-input v-model="code" autocomplete="off" />
				</el-form-item>
			</div>
			<el-form-item>
				<el-button type="primary" @click="submitForm(verType)">下一步</el-button>
			</el-form-item>
		</el-form>
		<el-result v-else icon="warning" title="请联系客服处理" />
		<!-- 图形验证码 -->
		<el-dialog align-center v-model="captchaVisible" title="请输入图片中的验证码" width="280">
			<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
		    <el-form class="captcha-form">
		      <el-form-item label="验证码">
		        <el-input v-model="captchaAnswer" autocomplete="off" />
		      </el-form-item>
		    </el-form>
		    <template #footer>
		      <div class="dialog-footer">
		        <el-button type="primary" @click="captchaClick(verType)">确定发送验证码</el-button>
		      </div>
		    </template>
		</el-dialog>
    </div>
</template>

<script>
	import { ElMessage } from 'element-plus';
	import { captchaFetch,sendemailcode,sendsmscode,checksecvarcode } from '@/api/common'
	import { getUserInfo } from '@/api/account'
	
	export default {
		components: {
		    ElMessage
		},
		props: {
		    secverType: String
		  },
		data() {
			return {
			  verType: 'mobile',
			  mobile: '',
			  mobileSend: false,
			  mobileSendText: '发送验证码',
			  mobileTime: 60,
			  email: '',
			  emailSend: false,
			  emailSendText: '发送验证码',
			  emailTime: 60,
			  code:'',
			  question: '',
			  answer: '',
			  questionCheckOk:false,
			  userInfo:'',
			  formLabelWidth:'160px',
			  captchaImg:'',
			  captchaId:'',
			  captchaAnswer:'',
			  captchaVisible: false
			};
		},
		methods: {
			getUserInfoF(){
				getUserInfo().then((res) => {
					if(res.code == 200){
						this.userInfo = res.data;
						this.mobile = res.data.mobileEncrypt;
						this.email = res.data.emailEncrypt;
						this.question = res.data.question;
						this.questionCheckOk = res.data.checkQuestion
					}
				})
			},
			wayChange(val) {
				this.verType = val;
			},
			captchaChange(val) {
				captchaFetch().then((res) => {
					if (res.code == 200) {
						this.captchaImg = res.data.captcha_data;
						this.captchaId = res.data.captcha_id;
					}
				})
			},
			captchaReload() {
				this.captchaChange()
			},
			codeChange() {
				this.captchaChange()
				this.captchaVisible = !this.captchaVisible
			},
			captchaClick(val) {
				const param = {'captcha_answer':this.captchaAnswer,'captcha_id':this.captchaId,'way':this.secverType}
				if(val == 'mobile'){
					sendsmscode(param).then((res) => {
						if (res.code == 200) {
							this.mobileSend = true
							this.mobileSendText = this.mobileTime+'s后重新发送'
							let timer = setInterval(() => {
							   this.mobileTime--
							   this.mobileSendText = this.mobileTime + 's后重新发送'
							   if (this.mobileTime < 0) {
								   clearInterval(timer)
								   this.mobileSendText = '发送验证码'
								   this.mobileTime = 60
								   this.mobileSend = false
							   }
							}, 1000)
							this.captchaVisible = !this.captchaVisible
						}else{
							this.captchaChange()
							this.captchaAnswer = ''
						}
					})
				}
				if(val == 'email' ){
					sendemailcode(param).then((res) => {
						if (res.code == 200) {
							this.emailSend = true
							this.emailSendText = this.emailTime+'s后重新发送'
							let timer = setInterval(() => {
							   this.emailTime--
							   this.emailSendText = this.emailTime + 's后重新发送'
							   if (this.emailTime < 0) {
								   clearInterval(timer)
								   this.emailSendText = '发送验证码'
								   this.emailTime = 60
								   this.emailSend = false
							   }
							}, 1000)
							this.captchaVisible = !this.captchaVisible
						}else{
							this.captchaChange()
							this.captchaAnswer = ''
						}
					})
				}
			},
			submitForm(val) {
				const param = {'code':this.code,'way':val}
				checksecvarcode(param).then((res) => {
					if (res.code == 200) {
						this.$emit('tokenChange',true,this.verType)
					}
				})
			}
		},
		created () {
		  this.getUserInfoF()
		}
	};
</script>
<style lang="scss" scoped>
	.code{
		overflow: hidden;
		.el-form-item{
			width: 42%;
			float: left;
			.el-input{width: 100%; margin-right: 20px;}
		}
	}
</style>